import { useCallback, useContext } from 'react';
import { INVOICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { isReadOnly } from 'customer-data-objects/property/PropertyIdentifier';
import { AccessLevelContext, getAccessLevelWithCaching } from 'customer-data-properties/accessLevel/AccessLevelContext';
import { NOT_SPECIFIED } from 'customer-data-objects/property/AccessLevel';
import http from 'hub-http/clients/apiClient';
import { castPropertyToAny } from '../utils/properties';
export const usePropertyDisplay = (objectTypeId, currentUserCanEdit) => {
  const accessLevelContext = useContext(AccessLevelContext);
  const isSystemProperty = useCallback(property => {
    const isInvoiceProperty = objectTypeId === INVOICE_TYPE_ID && property.name !== 'hubspot_owner_id';
    return isReadOnly(castPropertyToAny(property)) || isInvoiceProperty;
  }, [objectTypeId]);
  const getPropertyDisplay = useCallback(property => {
    const accessLevel = getAccessLevelWithCaching({
      context: accessLevelContext,
      objectType: objectTypeId,
      propertyName: property.name,
      httpClient: http
    });
    const hasEditPermission = accessLevel === null || accessLevel === NOT_SPECIFIED;
    const readOnly = !currentUserCanEdit || isSystemProperty(property) || !hasEditPermission;
    return {
      isReadOnly: readOnly
    };
  }, [accessLevelContext, currentUserCanEdit, isSystemProperty, objectTypeId]);
  return {
    getPropertyDisplay
  };
};